import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Button } from '@mentimeter/ragnar-ui/button';
import { MentimeterSymbol } from '@mentimeter/ragnar-visuals';
import { useTranslate } from '../../localization/translate';

export const ModuleError = () => {
  const translate = useTranslate();

  return (
    <Box alignItems="center" gap="space6">
      <Box width="100%" alignItems="center" mt="space4" mb="space2">
        <MentimeterSymbol width={40} height={40} />
      </Box>
      <Text
        fontFamily="heading"
        lineHeight="heading"
        fontSize="175"
        as="h1"
        textAlign="center"
      >
        {translate('messages.sorry_for_the_inconvenience')}
      </Text>
      <Text>{translate('messages.there_was_an_issue_please_try_again')}</Text>
      <Button
        size="large"
        variant="primary"
        onClick={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
      >
        {translate('buttons.try_again')}
      </Button>
    </Box>
  );
};
